import React from 'react'
import WelcomeUmow from '../components/WelcomeUmow/WelcomeUmow'

const UmowSie = () => {
	return (
		<>
			<WelcomeUmow />
		</>
	)
}

export default UmowSie
